/* eslint-disable complexity */
import React from 'react';
import cx from 'classnames';
import { useTranslations } from '@unisporkal/localization';
import { useTheme } from '@unisporkal/themes';
import {
  Typography,
  TypographyComponentEnum,
  TypographyVariant,
} from '@unisporkal/alliance-ui';
import { ImageSize } from 'types/isomorphic';
import modifiedSizeCopy from '../support/modifiedSizeCopy';
import WhatToExpect from '../WhatToExpect/WhatToExpect';
import styles from '../ModifiedBuyCard.module.scss';

interface ModifiedImageRowProps {
  size: ImageSize;
  selected: boolean;
  onSelect: (size: ImageSize) => void;
}

const ModifiedImageRow = ({
  size,
  selected,
  onSelect,
}: ModifiedImageRowProps) => {
  const t = useTranslations();
  const theme = (useTheme as () => { radio?: { radioButton?: string } })();
  const themeRadio = theme.radio || {};
  const copy = modifiedSizeCopy(size.sizeName);
  const title = copy ? t(copy.titleKey) : size.sizeName;
  const description = copy ? t(copy.descriptionKey) : '';
  const whatToExpectKeys = copy ? copy.whatToExpectKeys : [];

  return (
    <div
      className={cx(styles.optionCard, {
        [styles.optionCardSelected]: selected,
      })}
      data-testid={`modified-image-${size.sizeName}`}
    >
      <label className={styles.optionHeader}>
        <input
          type="radio"
          name="modified-image-size"
          className={cx(themeRadio.radioButton, styles.radio)}
          checked={selected}
          onChange={() => onSelect(size)}
        />
        <div className={styles.optionText}>
          <Typography
            component={TypographyComponentEnum.DIV}
            variant={TypographyVariant.body.medium}
            className={styles.optionLabel}
          >
            {title}
          </Typography>
          <Typography
            component={TypographyComponentEnum.DIV}
            variant={TypographyVariant.body.xsmall}
            className={styles.dimensionsLine}
          >
            {t('img_size_in_pixels', {
              width: size.width,
              height: size.height,
            })}
          </Typography>
          {description && (
            <Typography
              component={TypographyComponentEnum.DIV}
              variant={TypographyVariant.body.xsmall}
              className={styles.optionDescription}
            >
              {description}
            </Typography>
          )}
        </div>
      </label>
      {whatToExpectKeys.length > 0 && (
        <WhatToExpect
          sizeName={size.sizeName}
          itemKeys={whatToExpectKeys}
        />
      )}
    </div>
  );
};

export default ModifiedImageRow;
